<template>
  <v-card :class="$vuetify.breakpoint.smAndDown && 'grey lighten-3'"
          :outlined="$vuetify.breakpoint.mdAndUp"
          :tile="$vuetify.breakpoint.smAndDown"
          class="fill-height">
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <v-card-title>{{ $t('production_timeline.unqueued') }}</v-card-title>
      <v-divider/>
    </template>
    <v-card-text class="queue-scroll py-2 px-1">

      <v-fade-transition group hide-on-leave>
        <template v-if="loading">
          <project-card-skeleton-loader v-for="i in [1, 2, 3]" :key="i"/>
        </template>
      </v-fade-transition>

      <v-fade-transition hide-on-leave>
        <template v-if="!loading">
          <component
            :is="isAdmin ? 'draggable' : 'div'"
            :list="projectLogs"
            class="list-group"
            group="projects"
            handle=".handle"
            @change="(e) => $emit('drag-change', e)">
            <project-card v-for="projectLog in projectLogs"
                          :key="projectLog.id"
                          :project-log="projectLog"
                          :production-lines="productionLines"
                          :is-unscheduled="true"
                          class="list-group-item"
                          @assign-to-line="(e) => $emit('assign-to-line', e)"/>
            <no-content-view
              v-if="!loading && projectLogs.length === 0"
              :class="$vuetify.breakpoint.smAndUp ? 'pt-10' : ''"
              :description="hasAnyProjects ? $t('production_timeline.no_unqueued_projects_description') : $t('production_timeline.no_projects_found_description')"
              :function-button="!hasAnyProjects"
              :function-button-text="$t('production_timeline.reload_projects')"
              :prop-function="() => $emit('reload')"
              :reload-button="false"
              :title="hasAnyProjects ? $t('production_timeline.no_unqueued_projects') : $t('production_timeline.no_projects_found')"
              dense
              function-button-icon="mdi-refresh"
              title-icon="mdi mdi-store-24-hour"/>
          </component>
        </template>
      </v-fade-transition>

    </v-card-text>
  </v-card>
</template>

<script>
import Draggable from 'vuedraggable';
import ProjectCard from './ProjectCard';
import ProjectCardSkeletonLoader from './ProjectCardSkeletonLoader';
import NoContentView from '@/components/NoContentView';

export default {
  name: 'UnscheduledColumn',
  components: { Draggable, ProjectCard, ProjectCardSkeletonLoader, NoContentView },
  props: {
    projectLogs: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    hasAnyProjects: {
      type: Boolean,
      default: false
    },
    productionLines: {
      type: Array,
      default: () => []
    }
  }
};
</script>
